$(function () {
    $(document).scroll(function () {

        var t = $(document).scrollTop();
        var parallax = .4;
        var posY = 700 - (t * parallax);
        $(".stems-public.jumbotron").css("background-position", "0 " + posY + "px");

        if (t >= 80) {
            $(".navbar-stems.jumbo").stop(true, false).animate({
                padding: "0px",
                backgroundColor: "rgba(0,0,0,0.7)"
            }, 250);
        }
        else {
            $(".navbar-stems.jumbo").stop(true, false).animate({
                padding: "10px",
                backgroundColor: "transparent"
            }, 250);
        }
    });
});